<script>
export default {
  name: "TheStudentRatingTableStatements",

  props: {
    statements: Array,
  },

  data() {
    return {
      page: 1,
      itemsPerPage: 999,
      headers: [
        {
          text: 'Место',
          value: 'Number',
          groupable: false,
          sortable: false,
          width: '6%',
          align: "center",
          cellClass: "text-body-1",
        },
        {
          text: 'Участник',
          value: 'participant',
          groupable: false,
          sortable: false,
          width: '25%',
          class: "name-column",
        },
        {
          text: 'Тип деятельности',
          value: 'achievement_type_name',
          groupable: false,
          sortable: false,
          width: '35%',
          divider: true,
        },
        {
          text: 'Сумма по деятельности',
          value: 'sum_score_selected_activity',
          groupable: false,
          sortable: false,
          width: '13%',
          align: 'center',
        },
        {
          text: 'Общая сумма баллов',
          value: 'sum_score',
          groupable: false,
          sortable: false,
          width: '13%',
          divider: true,
          align: 'center',
        },
        {
          text: 'Посмотреть',
          value: 'views',
          groupable: false,
          sortable: false,
          width: '8%',
          align: 'center',
        },
      ],
    }
  },

  computed: {
    numberOfPages () {
      return Math.ceil(this.statements.length / this.itemsPerPage)
    },

  },

  methods: {
    showDimensionsStatements(id) {
      this.$emit('openStatement', id);
    },

    shortName(fullName) {
      const convertFullName = fullName.split(" ");
      const surname = convertFullName[0];

      let name = "";
      if (convertFullName.length > 1) {
        name = convertFullName[1].charAt(0) + ".";
      }

      let patronymic = "";
      if (convertFullName.length > 2) {
        const firstLetterPatronymic = convertFullName[2].charAt(0) + ".";
        patronymic = " " + firstLetterPatronymic;
      }

      return surname + " " + name + patronymic;

    },


  },

}
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="statements"
    hide-default-footer
    class="text-body-1"
    item-key="id"
    height="60vh"
    :items-per-page="itemsPerPage"
    :page.sync="page"
  >
    <template #loading>
      Идет загрузка...
    </template>

    <template #no-data>
      Отсутствуют заявления
    </template>

    <template #item.Number="{item, index}">
      {{statements.indexOf(item) + 1}}
    </template>

    <template #item.views="{item, index}">
      <v-btn
        icon
        small
        @click="showDimensionsStatements(item.id)"
      >
        <v-icon small>
          fa-eye
        </v-icon>
      </v-btn>
    </template>

    <template #item.sum_score_selected_activity="{item, index}">
      <v-chip small>
        <v-icon small left>
          fa-certificate
        </v-icon>
        {{item.sum_score_selected_activity}}
      </v-chip>
    </template>

    <template #item.sum_score="{item, index}">
      <v-chip small>
        <v-icon small left>
          fa-trophy
        </v-icon>
        {{item.sum_score}}
      </v-chip>
    </template>

    <template #item.participant="{item, index}">
      <v-list-item class="px-0">
        <v-list-item-content>
          <v-list-item-title>
            {{shortName(item.person_full_name)}}
          </v-list-item-title>
          <v-list-item-subtitle>
            Группа {{item.group_name}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

  </v-data-table>
</template>

<style scoped>

</style>